// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Detail shell — shared geometry for the by-id views (causa & diligencia).
   Canon: prototype dhead/dnav/dbody ladder (norm.css) + Concepto B columns
   (propuestas.css .cb-*). The head itself is PageHead (kicker → title +
   actions → sub → meta); this file adds the bands below it. Lifted from the
   page-scoped dd-*/
cd-* copies that DiligenciaDetalleVista.css promised to
   share once a second view needed them. */

/* ── page shells of the two by-id views: same minimum canvas ── */
.cd-page,
.dd-page {
  min-height: 720px;
}

/* ── nav band: tabs (causa) or 5-stage stepper (diligencia), same Y ── */
.dnav {
  margin-top: 24px;
  min-height: 46px;
  border-bottom: 1px solid var(--rule);
  display: flex;
  align-items: center;
}
/* .tabs carries its own bottom rule when standalone; inside the band the
   band owns it (avoids a double hairline, keeps .tab--on's underline on it). */
.dnav > .tabs {
  border-bottom: 0;
  align-self: stretch;
  flex: 1;
}
.dnav .stepper2 {
  margin-bottom: 0;
}

/* ── body: aside 322px left | panel right (Concepto B) ── */
.dbody {
  margin-top: 24px;
}
.cb-cols {
  display: grid;
  grid-template-columns: 322px 1fr;
  gap: var(--s-8);
  align-items: start;
}
@media (max-width: 900px) {
  .cb-cols {
    grid-template-columns: 1fr;
  }
  /* Stacked single column: a sticky aside would pin over the content. */
  .cb-aside {
    position: static;
  }
}
.cb-aside {
  /* canon says top:76px against the prototype topbar; the app topbar is
     taller — keep the app's existing rail offset. */
  position: sticky;
  top: 92px;
}
.cb-fichahead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

/* ── data rows (mono label | value) used by both asides ── */
.dd-info {
  border: 1px solid var(--border, #d9d2bd);
  background: var(--bg-alt, #fcfaf2);
  padding: 4px 15px;
}
.dd-info__row {
  display: grid;
  grid-template-columns: 150px 1fr;
  column-gap: 22px;
  align-items: baseline;
  padding: 11px 0;
  border-bottom: 1px solid var(--rule-soft, #ece4ce);
}
.dd-info__row:last-child {
  border-bottom: 0;
}
.dd-k {
  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);
  font-size: 10.5px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted, #6b7287);
}
.dd-v {
  color: var(--text, #0e1428);
  text-align: left;
  font-size: 13.5px;
}
/* ── quiet icon action in the detail head (canon name; both views) ── */
.dd-iconbtn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid var(--border, #d9d2bd);
  border-radius: var(--radius-1, 2px);
  background: transparent;
  color: var(--text-secondary, #38415a);
  cursor: pointer;
}
.dd-iconbtn:hover {
  border-color: var(--text, #0e1428);
  color: var(--text, #0e1428);
}
.dd-iconbtn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
/* Icon presentation lives here so consumers don't have to inline it. */
.dd-iconbtn svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.4;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* ── not-found state (both by-id views) ── */
.detail-notfound {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding-top: 8px;
  max-width: 52ch;
}
.detail-notfound__body {
  font-size: var(--fs-note);
  color: var(--text-secondary, #38415a);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/detail.css"],"names":[],"mappings":"AAAA;;;;mBAImB;AACnB;;;;;;EAME,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;AACA;+EAC+E;AAC/E;EACE,gBAAgB;EAChB,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA,sEAAsE;EACtE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;oDACkD;EAClD,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,wCAAwC;EACxC,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,kDAAkD;AACpD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mEAAmE;EACnE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;AACA,wEAAwE;AACxE;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;EACxC,mCAAmC;EACnC,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA,uEAAuE;AACvE;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,SAAS;AACX","sourcesContent":["/* Detail shell — shared geometry for the by-id views (causa & diligencia).\n   Canon: prototype dhead/dnav/dbody ladder (norm.css) + Concepto B columns\n   (propuestas.css .cb-*). The head itself is PageHead (kicker → title +\n   actions → sub → meta); this file adds the bands below it. Lifted from the\n   page-scoped dd-*/\ncd-* copies that DiligenciaDetalleVista.css promised to\n   share once a second view needed them. */\n\n/* ── page shells of the two by-id views: same minimum canvas ── */\n.cd-page,\n.dd-page {\n  min-height: 720px;\n}\n\n/* ── nav band: tabs (causa) or 5-stage stepper (diligencia), same Y ── */\n.dnav {\n  margin-top: 24px;\n  min-height: 46px;\n  border-bottom: 1px solid var(--rule);\n  display: flex;\n  align-items: center;\n}\n/* .tabs carries its own bottom rule when standalone; inside the band the\n   band owns it (avoids a double hairline, keeps .tab--on's underline on it). */\n.dnav > .tabs {\n  border-bottom: 0;\n  align-self: stretch;\n  flex: 1;\n}\n.dnav .stepper2 {\n  margin-bottom: 0;\n}\n\n/* ── body: aside 322px left | panel right (Concepto B) ── */\n.dbody {\n  margin-top: 24px;\n}\n.cb-cols {\n  display: grid;\n  grid-template-columns: 322px 1fr;\n  gap: var(--s-8);\n  align-items: start;\n}\n@media (max-width: 900px) {\n  .cb-cols {\n    grid-template-columns: 1fr;\n  }\n  /* Stacked single column: a sticky aside would pin over the content. */\n  .cb-aside {\n    position: static;\n  }\n}\n.cb-aside {\n  /* canon says top:76px against the prototype topbar; the app topbar is\n     taller — keep the app's existing rail offset. */\n  position: sticky;\n  top: 92px;\n}\n.cb-fichahead {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n/* ── data rows (mono label | value) used by both asides ── */\n.dd-info {\n  border: 1px solid var(--border, #d9d2bd);\n  background: var(--bg-alt, #fcfaf2);\n  padding: 4px 15px;\n}\n.dd-info__row {\n  display: grid;\n  grid-template-columns: 150px 1fr;\n  column-gap: 22px;\n  align-items: baseline;\n  padding: 11px 0;\n  border-bottom: 1px solid var(--rule-soft, #ece4ce);\n}\n.dd-info__row:last-child {\n  border-bottom: 0;\n}\n.dd-k {\n  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);\n  font-size: 10.5px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--text-muted, #6b7287);\n}\n.dd-v {\n  color: var(--text, #0e1428);\n  text-align: left;\n  font-size: 13.5px;\n}\n/* ── quiet icon action in the detail head (canon name; both views) ── */\n.dd-iconbtn {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 1px solid var(--border, #d9d2bd);\n  border-radius: var(--radius-1, 2px);\n  background: transparent;\n  color: var(--text-secondary, #38415a);\n  cursor: pointer;\n}\n.dd-iconbtn:hover {\n  border-color: var(--text, #0e1428);\n  color: var(--text, #0e1428);\n}\n.dd-iconbtn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n/* Icon presentation lives here so consumers don't have to inline it. */\n.dd-iconbtn svg {\n  width: 15px;\n  height: 15px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.4;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* ── not-found state (both by-id views) ── */\n.detail-notfound {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  padding-top: 8px;\n  max-width: 52ch;\n}\n.detail-notfound__body {\n  font-size: var(--fs-note);\n  color: var(--text-secondary, #38415a);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
